// Test IDs for the public-facing meat wholesaler site.

export const NAV = {
  brand: 'nav-brand',
  productsLink: 'nav-products-link',
  craftLink: 'nav-craft-link',
  contactLink: 'nav-contact-link',
  quoteCta: 'nav-quote-cta',
};

export const HERO = {
  section: 'hero-section',
  headline: 'hero-headline',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
};

export const PILLARS = {
  section: 'pillars-section',
  tile: (slug) => `pillar-tile-${slug}`,
};

export const CATALOG = {
  section: 'catalog-section',
  filter: (slug) => `catalog-filter-${slug}`,
  card: (id) => `product-card-${id}`,
  cta: (id) => `product-cta-${id}`,
  grid: 'catalog-grid',
  empty: 'catalog-empty',
};

export const INQUIRY = {
  section: 'inquiry-section',
  form: 'inquiry-form',
  business: 'inquiry-business',
  name: 'inquiry-name',
  email: 'inquiry-email',
  phone: 'inquiry-phone',
  volume: 'inquiry-volume',
  category: (slug) => `inquiry-category-${slug}`,
  message: 'inquiry-message',
  submit: 'inquiry-submit',
  success: 'inquiry-success',
};

export const FOOTER = {
  section: 'footer-section',
  adminLink: 'footer-admin-link',
};

export const ADMIN = {
  page: 'admin-page',
  table: 'admin-inquiries-table',
  row: (id) => `admin-inquiry-row-${id}`,
  empty: 'admin-inquiries-empty',
};
